import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Input, Spin, Form, message, DatePicker, Radio, InputNumber,Table, Popover  } from 'antd';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';

import './completeWPAForm.css';
import '../newMain/newMain.css';

import saveImg from '../../public/img/newMain/Save.png';
import signImg from '../../public/img/newMain/Sign.png';
import SignModal from './signModal';
import NewMessage from '../../component/newMessage/newMessage';
import  trans  from './translation';
import moment from 'moment';//日期格式化导包
import { InfoCircleOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const CompleteWPAForm = (props) => {

    const history = useHistory();
    const { authorizationCode, lang } = useParams();

    const [tables, setTables] = useState([]);
    const messageRef = useRef();
    const [isLoad, setIsLoad] = useState(false);
    const [isShow, setIsShow] = useState(true);
    const [form] = Form.useForm();
    const [isFromDate, setIsFromDate] = useState(false);
    const [isToDate, setIsToDate] = useState(false);
    const [signatureImg, setSignatureImg] = useState("");
    const [isSignModal, setIsSignModal] = useState(false);
    const [language, setLanguage] = useState(lang ?? "EN");
    const [wpaApplModel, setWpaApplModel] = useState({});
    const activity1 = Form.useWatch('activity1', form);
    const activity2 = Form.useWatch('activity2', form);
    const activity3 = Form.useWatch('activity2', form);
    const [wpaQuestionModel, setWpaQuestionModel] = useState({});
    const [tables2, setTables2] = useState([
        {
            "id": 5,
            "score": 5,
            "performance": `${trans.completeWPAFormPart2_A_Excellent[language]}`,
            "descriptor": `${trans.completeWPAFormPart2_A_Excellent_desc[language]}`
        },
        {
            "id": 4,
            "score": 4,
            "performance": `${trans.completeWPAFormPart2_A_Good[language]}`,
            "descriptor": `${trans.completeWPAFormPart2_A_Good_desc[language]}`
        },
        {
            "id": 3,
            "score": 3,
            "performance": `${trans.completeWPAFormPart2_A_Satisfactory[language]}`,
            "descriptor": `${trans.completeWPAFormPart2_A_Satisfactory_desc[language]}`
        },
        {
            "id": 2,
            "score": 2,
            "performance": `${trans.completeWPAFormPart2_A_Acceptable[language]}`,
            "descriptor": `${trans.completeWPAFormPart2_A_Acceptable_desc[language]}`
        },
        {
            "id": 1,
            "score": 1,
            "performance": `${trans.completeWPAFormPart2_A_Unsatisfactory[language]}`,
            "descriptor": `${trans.completeWPAFormPart2_A_Unsatisfactory_desc[language]}`
        },
        {
            "id": 0,
            "score": 0,
            "performance": `${trans.completeWPAFormPart2_A_Unacceptable[language]}`,
            "descriptor": `${trans.completeWPAFormPart2_A_Unacceptable_desc[language]}`
        }
    ]);

    useEffect(() => {
        if (authorizationCode) {
            checkCode()
        } else {
            message.error("Link has failed.");
            setIsShow(false);
        }
    }, []);
    
    const checkCode = () => {
        if(isLoad) {
            return;
        }
        let model = {authorizationCode: authorizationCode};
        setIsLoad(true);
        fetch(Config.apiServer + "partner/wpaAppl/checkAuthorizationCode", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                setIsShow(true)
                searchById();
            } else {
                message.error(data.msg);
                setIsShow(false);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }
    
    const searchById = () => {
        let model = {authorizationCode: authorizationCode};
        fetch(Config.apiServer + "partner/wpaAppl/searchById", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                searchWpaQuestion(model);
                setWpaApplModel(model);
                initForm(model);
            } else {
                message.error(data.msg);
            }
        })
    }
    
    const searchWpaQuestion = (model) => {
        fetch(Config.apiServer + "partner/wpaAppl/searchWpaQuestion", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setWpaQuestionModel(model);
                let list = [];
                for(let i = 1; i <= 8; i++) {
                    if(model['wpaQuestion' + i + language]) {
                        list.push({
                            id: 'wpaQuestionResult' + i,
                            question: model['wpaQuestion' + i + language],
                        })
                    }
                }
                for(let i = 9; i <= 13; i++) {
                    if(model['programmeSpecificWpaQuestion' + i + language]) {
                        list.push({
                            id: 'wpaQuestionResult' + i,
                            question: model['programmeSpecificWpaQuestion' + i + language],
                        })
                    }
                }
                setTables(list);
            } else {
                console.log(data.msg);
            }
        })
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            wilHoursIs: model.wilHours ?? "",
            periodStartDateIs: model?.periodStartDate ? moment(model?.periodStartDate) : null,
            periodEndDateIs: model?.periodEndDate ? moment(model?.periodEndDate) : null,
            companyNameIs: model?.companyName ?? '',
            companyAddressIs: model?.companyAddress ?? '',
            industrySupervisorEmailIs: model?.industrySupervisorEmail ?? '',
            signatureDate: model?.signatureDate ? moment(model?.signatureDate) : moment(), 
        });
    }

    const jump = (path) => {
        history.replace(path);
    }

    const done = () => {
        messageRef.current.setIsShow(false)
    }
    
    const checkWilHour = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.wilHoursIsRequired[language]);
        }
        if (value && !/^\d{1,3}(\.\d{1,2})?$/.test(value)) {
            return Promise.reject(new Error(trans.wilHoursConnotGreater[language]));
        }
        return Promise.resolve();
    }

    const checkStartDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.periodStartDateIsRequired[language]);
        }
        if (Base.isNotEmpty(value)) {
            const endDate = form.getFieldValue('periodEndDate')
            if (Base.isNotEmpty(endDate)) {
                if (Base.afterDate(value, endDate)) {
                    if (!isToDate) {
                        setIsToDate(true);
                        form.validateFields(["periodEndDate"]);
                    }
                    return Promise.reject(trans.periodStartDateCannotLaterPeriodEndDate[language]);
                }
            }
        }
        if (isToDate) {
            form.validateFields(["periodEndDate"]);
        }
        setIsToDate(false);
        return Promise.resolve();
    }

    const checkEndDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject(trans.periodEndDateIsRequired[language]);
        }
        if (Base.isNotEmpty(value)) {
            const startDate = form.getFieldValue('periodStartDate')
            if (Base.isNotEmpty(startDate)) {
                if (Base.afterDate(startDate, value)) {
                    if (!isFromDate) {
                        setIsFromDate(true);
                        form.validateFields(["periodStartDate"]);
                    }
                    return Promise.reject(trans.periodEndDateCannotEarlierPeriodStartDate[language])
                }
            }
        }
        if (isFromDate) {
            form.validateFields(["periodStartDate"]);
        }
        setIsFromDate(false);
        return Promise.resolve();
    }

    useEffect(() => {
        if(!activity1) {
            form.setFields([
                {
                    name: 'activityProportion1',
                    errors: [],
                    value: ''
                },
            ]);
        }
    }, [activity1]);

    useEffect(() => {
        if(!activity2) {
            form.setFields([
                {
                    name: 'activityProportion2',
                    errors: [],
                    value: ''
                },
            ]);
        }
    }, [activity2]);

    useEffect(() => {
        if(!activity3) {
            form.setFields([
                {
                    name: 'activityProportion3',
                    errors: [],
                    value: ''
                },
            ]);
        }
    }, [activity3]);
    
    const checkTimeSpent1 = (value) => {
        if(activity1) {
            if (Base.isEmpty(value)) {
                return Promise.reject(trans.activityProportionIsRequired[language]);
            }
        }
        return Promise.resolve();
    }

    const checkTimeSpent2 = (value) => {
        if(activity2) {
            if (Base.isEmpty(value)) {
                return Promise.reject(trans.activityProportionIsRequired[language]);
            }
        }
        return Promise.resolve();
    }

    const checkTimeSpent3 = (value) => {
        if(activity3) {
            if (Base.isEmpty(value)) {
                return Promise.reject(trans.activityProportionIsRequired[language]);
            }
        }
        return Promise.resolve();
    }

    const openSignatureCanvasShow = () => {
        setIsSignModal(true);
    };

    const closeSignModel = (url) => {
        if (url) {
            setSignatureImg(url);
        }
        setIsSignModal(false);
    }

    const onFinish = (values) => {
        if (isLoad) {
            return;
        }
        if(!signatureImg) {
            message.error(trans.signatureImgIsRequired[language])
            return;
        }
        let total = 0;
        if(values.activity1) {
            total += Number(values.activityProportion1 ?? 0);
        }
        if(values.activity2) {
            total += Number(values.activityProportion2 ?? 0);
        }
        if(values.activity3) {
            total += Number(values.activityProportion3 ?? 0);
        }
        if(values.activity1 || values.activity2 || values.activity3) {
            if(total != 100) {
                message.error(trans.activityProportionEqual100[language]);
                return;
            }
        }
        setIsLoad(true);
        let model = {...wpaApplModel, ...values, wpaStatus: 'PENDING_REVIEW', authorizationCode: authorizationCode};
        model.signatureImgModel = {
            status: 'NEW',
            url: signatureImg,
        };
        fetch(Config.apiServer + "partner/wpaAppl/update", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                jump("/completeWPAFormThanks/" + authorizationCode);
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const columns = [
        {
            title: '',
            dataIndex: 'question',
            render: text => <div className='mustFill'>{text}</div>
        },
        {
            // title: '\xa05\xa0\xa0\xa0\xa0\xa04 \xa0\xa0\xa03\xa0\xa0\xa0\xa0\xa02\xa0\xa0\xa0\xa01\xa0\xa0\xa0\xa0 0',
            title: <div className='tableTitleFlexBox '>
                    <div className={language != 'EN' ? 'width50' : 'width80' }>
                        <div>5</div>
                        <div className='tableSmallTitle'>{tables2[0].performance}</div>
                    </div>
                    <div className={language != 'EN' ? 'width50' : 'width80' }>
                        <div>4</div>
                        <div className='tableSmallTitle'>{tables2[1].performance}</div>
                    </div>
                    <div className={language != 'EN' ? 'width50' : 'width80' }>
                        <div>3</div>
                        <div className='tableSmallTitle'>{tables2[2].performance}</div>
                    </div>
                    <div className={language != 'EN' ? 'width50' : 'width80' }>
                        <div>2</div>
                        <div className='tableSmallTitle'>{tables2[3].performance}</div>
                    </div>
                    <div className={language != 'EN' ? 'width50' : 'width80' }>
                        <div>1</div>
                        <div className='tableSmallTitle'>{tables2[4].performance}</div>
                    </div>
                    <div className={language != 'EN' ? 'width50' : 'width80' }>
                        <div>0</div>
                        <div className='tableSmallTitle'>{tables2[5].performance}</div>
                    </div>
                </div>,
            dataIndex: 'id',
            width: language != 'EN' ? 316 : 496,
            render: text => (
                <Form.Item
                    name={text}
                    rules={[
                        { required: true, message: trans.questionIsRequired[language] },
                    ]}
                >
                    <Radio.Group name="radiogroup" className='radioBox'>
                        <Radio value={5} className={language != 'EN' ? 'width50' : 'width80' }></Radio>
                        <Radio value={4} className={language != 'EN' ? 'width50' : 'width80' }></Radio>
                        <Radio value={3} className={language != 'EN' ? 'width50' : 'width80' }></Radio>
                        <Radio value={2} className={language != 'EN' ? 'width50' : 'width80' }></Radio>
                        <Radio value={1} className={language != 'EN' ? 'width50' : 'width80' }></Radio>
                        <Radio value={0} className={language != 'EN' ? 'width50' : 'width80' }></Radio>
                    </Radio.Group>
                </Form.Item>
            ),
        },
    ];
    const columns2 = [
        {
            title: `${trans.completeWPAFormScore[language]}`,
            dataIndex: 'score',
            width: 120,
            className: ' sysControls',
        },
        {
            title: `${trans.completeWPAFormPerformance[language]}`,
            dataIndex: 'performance',
            width: 360,
            className: ' sysControls',
        },
        {
            title: `${trans.completeWPAFormDescriptor[language]}`,
            dataIndex: 'descriptor',
        },
    ];
    return (
        <div id="container" className='websiteTemplate completeWPAForm'>
            <NewMessage ref={messageRef} done={done} />
            {isSignModal && <SignModal onClose={closeSignModel} language={language} signatureImg={signatureImg}/>}
            {isShow ? <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className='detailStatusBox'>
                        <div className='detailTitle'>{trans.completeWPAFormTop[language]}</div>
                    </div>
                    <div className='websiteSysButtonBox'>
                        <div className='websiteSysButton saveButton' onClick={() => form.submit()}><img src={saveImg} />{trans.completeWPAFormSave[language]}</div>
                    </div>
                </div>
                <div className=''>
                    <Form form={form} onFinish={onFinish}>
                        <div className='websiteSysContentBox'>
                            <div className='contentTitle'>
                                {trans.completeWPAFormTitle[language]}
                            </div>
                            <div className='flexBox'>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormDesc[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormDesc2[language]}
                                </div>
                            </div>

                            <div className='contentTitle'>
                                {trans.completeWPAFormAttention[language]}
                            </div>
                            <div className='flexBox'>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention1[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention2[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention3[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention4[language]}
                                </div>
                                <div className='value valueJustify boxWidMax'>
                                    {trans.completeWPAFormAttention5[language]}
                                </div>
                            </div>
                            <div className="sysTable" id="tableOne">
                                <div className='contentTitle centerBox'>
                                    {trans.completeWPAFormRatingScale[language]}
                                </div>
                                <Table
                                    scroll={{ x: 700 }}
                                    rowKey="id"
                                    columns={columns2} //列名
                                    dataSource={tables2} //数据
                                    pagination={false}
                                />
                            </div>
                        </div>
                        <div className='websiteSysContentBox'>
                            <div className='contentTitle'>
                                {trans.completeWPAFormPart1[language]}
                            </div>
                            <div className='contentTitle'>
                                {trans.completeWPAFormStuInfo[language]}
                            </div>
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam ">{trans.completeWPAFormStuName[language]}</div>
                                    <div className="websiteSysInput">
                                        <Input className="input" type="text" placeholder={trans.completeWPAFormStuName[language]} value={wpaApplModel?.firstName + ' ' + wpaApplModel?.lastName} disabled />
                                    </div>
                                </div>
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam ">{trans.completeWPAFormStuID[language]}</div>
                                    <div className="websiteSysInput">
                                        <Input className="input" type="text" placeholder={trans.completeWPAFormStuID[language]} value={wpaApplModel?.studentAcctId} disabled />
                                    </div>
                                </div>
                            </div>
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam ">{trans.completeWPAFormPro[language]}</div>
                                    <div className="websiteSysInput">
                                        <Input className="input" type="text" placeholder={trans.completeWPAFormPro[language]} value={wpaApplModel?.progTitle} disabled />
                                    </div>
                                </div>
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam ">{trans.completeWPAFormWILCourseCode[language]}</div>
                                    <div className="websiteSysInput">
                                        <Input className="input" type="text" placeholder={trans.completeWPAFormWILCourseCode[language]} value={wpaApplModel?.moduleCode} disabled />
                                    </div>
                                </div>
                            </div>
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam ">{trans.completeWPAFormWILCourseTitle[language]}</div>
                                    <div className="websiteSysInput">
                                        <Input className="input" type="text" placeholder={trans.completeWPAFormWILCourseTitle[language]} value={wpaApplModel?.moduleName} disabled />
                                    </div>
                                </div>
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam mustFill">{trans.completeWPAFormWILHours[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="wilHoursIs"
                                            rules={[
                                                { required: true, validator: (rule, value) => checkWilHour(value) },
                                            ]}
                                        >
                                            <InputNumber precision={1} maxLength={5} min={0} placeholder={trans.completeWPAFormWILHours[language]} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam mustFill">{trans.completeWPAFormWILPeriod[language]}</div>
                                    <div className="websiteSysInput dateInput">
                                        <Form.Item
                                            name="periodStartDateIs"
                                            rules={[
                                                { required: true, validator: (rule, value) => checkStartDate(value) },
                                            ]}
                                        >
                                            <DatePicker placeholder={trans.completeWPAFormStartDate[language]}
                                                className="parts-numberInput datePickerAllWidth"
                                                format={Config.dateFormatEn}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode} />
                                        </Form.Item>
                                        <div style={{ width: "10px" }}>-</div>
                                        <Form.Item
                                            name="periodEndDateIs"
                                            rules={[
                                                { required: true, validator: (rule, value) => checkEndDate(value) },
                                            ]}
                                        >
                                            <DatePicker placeholder={trans.completeWPAFormEndDate[language]}
                                                className="parts-numberInput datePickerAllWidth"
                                                format={Config.dateFormatEn}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="websiteSysCol"></div>
                            </div>
                            <div className='contentTitle'>
                                {trans.completeWPAFormComInfo[language]}
                            </div>
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam mustFill">{trans.completeWPAFormComName[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="companyNameIs"
                                            rules={[
                                                { required: true, message: trans.companyNameIsRequired[language] },
                                            ]}
                                        >
                                            <Input className="input" type="text" placeholder={trans.completeWPAFormComName[language]} maxLength={100} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam mustFill">{trans.completeWPAFormComAddress[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="companyAddressIs"
                                            rules={[
                                                { required: true, message: trans.companyAddressIsRequired[language] },
                                            ]}
                                        >
                                            <Input className="input" type="text" placeholder={trans.completeWPAFormComAddress[language]} maxLength={400} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='contentTitle'>
                                {trans.completeWPAFormIndInfo[language]}
                            </div>
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam mustFill">{trans.completeWPAFormIndName[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="industrySupervisorNameIs"
                                            rules={[
                                                { required: true, message: trans.industrySupervisorNameIsRequired[language] },
                                            ]}
                                        >
                                            <Input className="input" type="text" placeholder={trans.completeWPAFormIndName[language]} maxLength={50} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam mustFill">{trans.completeWPAFormIndPosition[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="industrySupervisorPositionIs"
                                            rules={[
                                                { required: true, message: trans.industrySupervisorPositionIsRequired[language] },
                                            ]}
                                        >
                                            <Input className="input" type="text" placeholder={trans.completeWPAFormIndPosition[language]} maxLength={50} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam mustFill">{trans.completeWPAFormIndPhone[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="industrySupervisorPhoneIs"
                                            rules={[
                                                { required: true, message: trans.industrySupervisorPhoneIsRequired[language] },
                                            ]}
                                        >
                                            <InputNumber placeholder={trans.completeWPAFormIndPhone[language]} maxLength={12} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="websiteSysCol">
                                    <div className="websiteSysParam mustFill">{trans.completeWPAFormIndEmail[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="industrySupervisorEmailIs"
                                            rules={[
                                                { required: true, message: trans.industrySupervisorEmailIsRequired[language] },
                                                { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: trans.incorrectEmail[language] },
                                            ]}
                                        >
                                            <Input className="input" type="text" placeholder={trans.completeWPAFormIndEmail[language]} maxLength={50} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='websiteSysContentBox'>
                            <div className="contentTitle">{trans.completeWPAFormPart2[language]}</div>
                            <div className="contentTitle marginBottom15">{trans.completeWPAFormPart2_A[language]}</div>
                            <div className='flexBox'>
                                <div className='value valueJustify'>{trans.completeWPAFormMajorDesc[language]}</div>
                            </div>
                            <div className='websiteSysButtonRow'>
                                <div className='detailStatusBox'>
                                    <div className='contentTitle2'>{trans.completeWPAFormMajorAct[language]}</div>
                                </div>
                                <div className='websiteSysButtonBox'>
                                    <div className='contentTitle2' >{trans.completeWPAFormMajorActTime[language]}</div>
                                </div>
                            </div>
                            <div className='websiteSysRow'>
                                <div className='websiteSysCol'>
                                    <div className='label '>{trans.completeWPAFormMajorAct1[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="activity1"
                                        >
                                            <Input className="input" type="text"  maxLength={400} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='websiteSysColMin'>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="activityProportion1"
                                            rules={[
                                                { required: false, validator: (rule, value) => checkTimeSpent1(value) },
                                            ]}
                                        >
                                            <InputNumber className="input" type="text" maxLength={6} precision={2} min={0} max={100} addonAfter={"%"}/>
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='websiteSysRow'>
                                <div className='websiteSysCol'>
                                    <div className='label '>{trans.completeWPAFormMajorAct2[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="activity2"
                                        >
                                            <Input className="input" type="text"  maxLength={400} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='websiteSysColMin'>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="activityProportion2"
                                            rules={[
                                                { required: false, validator: (rule, value) => checkTimeSpent2(value) },
                                            ]}
                                        >
                                            <InputNumber className="input" type="text" maxLength={6} precision={2} min={0} max={100} addonAfter={"%"} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='websiteSysRow'>
                                <div className='websiteSysCol'>
                                    <div className='label '>{trans.completeWPAFormMajorAct3[language]}</div>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="activity3"
                                        >
                                            <Input className="input" type="text"  maxLength={400} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className='websiteSysColMin'>
                                    <div className="websiteSysInput">
                                        <Form.Item
                                            name="activityProportion3"
                                            rules={[
                                                { required: false, validator: (rule, value) => checkTimeSpent3(value) },
                                            ]}
                                        >
                                            <InputNumber className="input" type="text" maxLength={6} precision={2} min={0} max={100} addonAfter={"%"} />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                            <div className='flexBox'>
                                <div className='websiteSysCol'></div>
                                <div className='websiteSysColMin flexBox'>
                                    <div className='label'></div>
                                    <div className='value'>{trans.completeWPAFormMajorActTimeSpent[language]}</div>
                                </div>
                            </div>
                            <div className="contentTitle marginBottom15 labelCircleBox">
                                {trans.completeWPAFormPart2_B[language]}
                                <Popover placement="right" content={<div style={{ maxWidth: "500px", textAlign: 'justify' }}>
                                    {language === 'EN' ? wpaQuestionModel?.IBoxContent : wpaQuestionModel?.['IBoxContent' + language]}
                                </div>} trigger="hover">
                                    <div className='labelCircle'><InfoCircleOutlined /></div>
                                </Popover>
                            </div>
                            <div className="sysTable completeWPAForm2 marginBottom15" id="tableOne">
                                <Table
                                    scroll={{ x: 500 }}
                                    rowKey="id"
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={false}
                                />
                            </div>

                            <div className="contentTitle sectionTitleMax">{trans.completeWPAFormPart2_C[language]}</div>
                            <div className='flexBox sectionTitle'>
                                <div className='value valueJustify mustFill'>{trans.completeWPAFormPart2_C_Desc[language]}</div>
                            </div>
                            <div className="checkbox">
                                <Form.Item
                                    name="workPerformance"
                                    rules={[
                                        { required: true, message: trans.workPerformanceIsRequired[language] },
                                    ]}
                                >
                                    <Radio.Group 
                                        options={[
                                            {
                                                label: `${trans.completeWPAFormPart2_A_Excellent[language]} (5)`,
                                                value: '5',
                                            },
                                            {
                                                label: `${trans.completeWPAFormPart2_A_Good[language]} (4)`,
                                                value: '4',
                                            },
                                            {
                                                label: `${trans.completeWPAFormPart2_A_Satisfactory[language]} (3)`,
                                                value: '3',
                                            },
                                            {
                                                label: `${trans.completeWPAFormPart2_A_Acceptable[language]} (2)`,
                                                value: '2',
                                            },
                                            {
                                                label:  `${trans.completeWPAFormPart2_A_Unsatisfactory[language]} (1)`,
                                                value: '1',
                                            },
                                            {
                                                label: `${trans.completeWPAFormPart2_A_Unacceptable[language]} (0)`,
                                                value: '0',
                                            },
                                        ]}
                                    />
                                </Form.Item>
                            </div> 
                            <div className='flexBox margin20'>
                                <div className='value valueJustify'>{trans.completeWPAFormPart2_C_Top[language]}</div>
                            </div>
                            <div className="websiteSysCol margin20">
                                <div className="websiteSysParam150  label">{trans.completeWPAFormPart2_C_1[language]}</div>
                                <div className="websiteSysInputMax">
                                    <Form.Item
                                        name="strengthArea"
                                    >
                                        <TextArea maxLength={1000} rows={3} placeholder="" />
                                    </Form.Item>
                                </div>
                            </div>
                                
                            <div className="websiteSysCol margin20">
                                <div className="websiteSysParam150  label">{trans.completeWPAFormPart2_C_2[language]}</div>
                                <div className="websiteSysInputMax">
                                    <Form.Item
                                        name="growthArea"
                                    >
                                        <TextArea maxLength={1000} rows={3} placeholder="" />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className='flexBox margin20'>
                                <div className='value valueJustify'>{trans.completeWPAFormPart2_C_3[language]}</div>
                            </div>
                            <div className="flexBox margin20">
                                <div className="websiteSysInputMax">
                                    <Form.Item
                                        name="workPerformanceComment"
                                    >
                                        <TextArea maxLength={1000} rows={3} placeholder="" />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysRow">
                                <div className="websiteSysCol">
                                    <div className="websiteSysParamMin mustFill label">{trans.completeWPAFormPart2_C_name[language]}</div>
                                    <div className="websiteSysInput websiteSysInputMin">
                                        <Form.Item
                                            name="signature"
                                            rules={[
                                                { required: true, message: trans.signatureIsRequired[language] },
                                            ]}
                                        >
                                            <Input className="input" type="text"  maxLength={50} placeholder={trans.completeWPAFormPart2_C_name[language]} />
                                        </Form.Item>
                                    </div>
                                    <div className="websiteSysParamMin2 mustFill label">{trans.completeWPAFormPart2_C_date[language]}</div>
                                    <div className="websiteSysInput websiteSysInputMin">
                                        <Form.Item
                                            name="signatureDate"
                                            rules={[
                                                { required: true, message: trans.signatureDateIsRequired[language] },
                                            ]}
                                        >
                                            <DatePicker 
                                                className="parts-numberInput datePickerAllWidth"
                                                format={Config.dateFormatEn}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode} 
                                                placeholder={trans.completeWPAFormPart2_C_date[language]}
                                                />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="websiteSysCol">
                                    <div className="label mustFill">{trans.completeWPAFormPart2_C_logo[language]}</div>
                                    <div className="websiteSysInput websiteSysButtonBox">
                                        <div className="signImgBox">
                                            {signatureImg && <img src={signatureImg}></img>}
                                        </div>
                                        <div className='websiteSysButton signatureButton' onClick={() => openSignatureCanvasShow()}><img src={signImg} />{trans.signature[language]}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className='websiteSysButtonBox'>
                    <div className='websiteSysButton saveButton' onClick={() => form.submit()}><img src={saveImg} />{trans.completeWPAFormSave[language]}</div>
                </div>
            </Spin>
                : <div className='contentTitle justifyCenter'>Link has failed.</div>
            }
        </div>
    )

}

export default CompleteWPAForm;